export class GetTrackingData {
    static readonly type = '[Tracking] Get Last Positions';
    constructor(public gpsUnitIds?: string) {}
}
